import React, { useContext, useEffect, useState } from 'react';
import { getActiveSession } from '../services/AuthService';

const UserContext = React.createContext();

export const useUserContext = () => useContext(UserContext);

function UserProvider({ children }) {
  const [user, setUser] = useState({
    isActive: false,
    email: '',
  });

  useEffect(() => {
    getActiveSession()
      .then(data => {
        setUser({
          isActive: true,
          email: data.email,
        });
      })
      .catch((data) => {
        setUser({
          isActive: false,
          email: '',
        });
      });
  }, []);

  const context = { user, setUser };
  return <UserContext.Provider value={context}>{children}</UserContext.Provider>;
}

export { UserProvider };
export default UserContext;